import React, { useState } from 'react'
import Headerone from '../headerone/newMain'
import Bredcom from '../Bredcom/Main'

function AntiRaggingCell() {
    return (
        <>
            <Headerone />
            <Bredcom title="Home" subtitle="Anti Ragging Cell" />
            <section className="about-area about-p pt-120 pb-120 p-relative fix">
                <div className="animations-02">
                    <img src="/assets/img/bg/an-img-02.png" alt="contact-bg-an-01" />
                </div>
                <div className="container">
                    <div className="row justify-content-center align-items-center">                        
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="about-content s-about-content pl-15 wow fadeInRight  animated" data-animation="fadeInRight" data-delay=".4s" >
                                <div className="about-title second-title pb-25">                                    
                                    <h3>Internal Complaints Committee</h3>
                                </div>
                                <p>
                                Pursuant to Notification No. MVNU/GSCASH/16/012 dated 08.06.2016 regarding, constitution of previously known as Gender Sensitization Committee against Sexual Harassment as per the guidelines for the prevention and deterrence of sexual harassment in the workplace laid down by the Supreme Court of India in its 13 August 1997 Judgment on the Writ Petition (Criminal) Vishaka v. State of Rajasthan, and directed by UGC, New Delhi in this regard; MVN University had approved a Policy against Sexual Harassment atthe Workplace.
                                </p>
                            
                                <p><b>The Internal Complaints Committee shall comprise of the following members:</b></p>
                                <div className='table'>
                                    <table className='table table-bordered'>
                                        <thead className='table-light head_red'>
                                            <tr>
                                                <th>Sr. No</th>
                                                <th>Name</th>
                                                <th>Designation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1.</td>
                                                <td>Dr. Yogendra Singh</td>
                                                <td>Chairman</td>
                                            </tr>
                                            <tr>
                                                <td>2.</td>
                                                <td>Dr. Ashutosh Upadhayay</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>3.</td>
                                                <td>Ms. Geeta Sharma</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>4.</td>
                                                <td>Ms. Sakshi Garg</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>5.</td>
                                                <td>Mr. Ashutosh Kumar</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>6.</td>
                                                <td>Ms. Ritika Jaggi</td>
                                                <td>Member</td>
                                            </tr>
                                            <tr>
                                                <td>7.</td>
                                                <td>Ms. Astha 24BAPS1003 (SOSH)</td>
                                                <td>Student Representative</td>
                                            </tr>
                                            <tr>
                                                <td>8.</td>
                                                <td>Ms. Tanya 24MSD2013 (SBMC)</td>
                                                <td>Student Representative</td>
                                            </tr>
                                            <tr>
                                                <td>9.</td>
                                                <td>Ms. Khushi 23BSBТ1013 (АHS) </td>
                                                <td>Student Representative</td>
                                            </tr>
                                            <tr>
                                                <td>10.</td>
                                                <td>Dy. Registrar </td>
                                                <td>Member Secretary</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <p>The tenure of the committee members will be of two years from the date of this notification. This supersedes all the notifications/circular/office order issued in this subject so far.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AntiRaggingCell